import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { AppBundle } from 'src/api/optimalprint-sdk.d';
import getProductUid from 'src/store/design/selector/getProductUid';
import fetchEditorScenesOperation from 'src/store/editor/operation/fetchEditorScenesOperation';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import getEditorScenes from 'src/store/editor/selector/getEditorScenes';
import { Store } from 'src/store/index';
import getFirstBundledProductId from 'src/store/productBundle/selector/getFirstBundledProductId';
import useIntegrationLayer from 'src/util/hook/useIntegrationLayer';

const fetchAndSendSetSpreadBackgroundsOperation = (inputProductUid?: string) => async (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
  getState: () => Store,
) => {
  const { productUid } = useIntegrationLayer();
  let store = getState();
  const uid = inputProductUid || getProductUid(store) || productUid;
  const bundledProductId = getFirstBundledProductId(store);

  const applyGroundImages = (
    scenes: AppBundle.Api.Response.Design.V3.DesignPublicEditorScenesListV3Response.Scene[],
  ) => {
    // Shaped products (ornaments, die-cut items) carry a mask scene; the editor clips the photo
    // to it so the customer sees what falls outside the printed shape. Every type is sent even
    // when empty, so switching to a product without one clears the previous product's image.
    const messageTypeBySceneType = {
      background: MESSAGE_TYPE['design.spreadBackgrounds'],
      foreground: MESSAGE_TYPE['design.spreadForegrounds'],
      mask: MESSAGE_TYPE['design.spreadMasks'],
    };
    Object.entries(messageTypeBySceneType).forEach(([sceneType, messageType]) => {
      sendPostMessage({
        type: messageType,
        data: scenes.filter((scene) => scene.type === sceneType),
      });
    });
  };

  if (uid) {
    let scenes = getEditorScenes(store, uid, bundledProductId);
    if (scenes) {
      applyGroundImages(scenes);
    } else {
      await dispatch(fetchEditorScenesOperation(uid, bundledProductId));
      store = getState();
      scenes = getEditorScenes(store, uid, bundledProductId);
      if (scenes) {
        applyGroundImages(scenes);
      }
    }
  }
};

export default fetchAndSendSetSpreadBackgroundsOperation;
